// stores/auth.js
import { defineStore } from 'pinia'
import api from '../api'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    user: null,
  }),
  actions: {
    async login(email, password, router) {
      const { data } = await api.post('loginUser', { email, password })

      this.token = data.token
      this.user = data.user

      localStorage.setItem('token', data.token)

      router.push('/')
    },

    logout() {
      this.token = ''
      this.user = null
      localStorage.removeItem('token')
    },

    initToken() {
      this.token = localStorage.getItem('token') || ''
    },
  },
})